import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import React from 'react'
import { i18n } from '../index'

type Props = {
  open: boolean
  loading: boolean
  maxDate: moment.Moment
  onClose: () => void
  onConfirm: (date: string) => void
}

type State = {
  selectedDate: moment.Moment | null
}

const DATE_FORMAT = 'YYYY-MM-DD'

class CopyFromDayDialog extends React.Component<Props, State> {
  state: State = {
    selectedDate: null,
  }

  onDateChange = (date: moment.Moment | null) => {
    this.setState({ selectedDate: date })
  }

  onConfirm = () => {
    const { selectedDate } = this.state
    if (!selectedDate || !selectedDate.isValid()) {
      return
    }
    this.props.onConfirm(selectedDate.format(DATE_FORMAT))
  }

  render() {
    const { open, loading, maxDate, onClose } = this.props
    const { selectedDate } = this.state
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
        <DialogTitle>{i18n.t('productTable.copyFromDayDialogTitle')}</DialogTitle>
        <DialogContent>
          <Alert severity='warning' sx={{ mb: 2 }}>
            {i18n.t('productTable.copyFromDayDialogWarning')}
          </Alert>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label={i18n.t('productTable.copyFromDayDatePickerLabel')}
              value={selectedDate}
              onChange={this.onDateChange}
              maxDate={maxDate}
              disabled={loading}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            {i18n.t('productTable.copyFromDayCancel')}
          </Button>
          <Button
            onClick={this.onConfirm}
            variant='contained'
            disabled={loading || !selectedDate || !selectedDate.isValid()}
          >
            {i18n.t('productTable.copyFromDayConfirm')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default CopyFromDayDialog
